<template>
	<div class="copyright">
		<p>
			©2025-现在
			<a class="icp-link" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">鄂ICP备16005966号</a>
			&ensp; 鄂B2-20250641 版权所有 武汉佳软信息技术有限公司
		</p>
		<a class="icp-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=42018502007998" rel="noreferrer" target="_blank">
			<img src="@/assets/icp.png" alt="" />
			&ensp; 鄂公网安备42018502007998号
		</a>
	</div>
</template>

<script>
	// 底部icp备案及版权所属
	export default {
		name: 'Copyright',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
